import React, { Component } from 'react';
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';
import { Styles } from "./styles/breadcrumb.js";
import { Link } from 'react-router-dom';
import UserService from '../../services/UserService.js';
import { useEffect } from 'react';
// import backgroundimg from "../../../public/assets/images/breadcrumb-bg."

import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie';


const languages = [

    {
        code: 'en',
        name: 'English',
        country_code: 'gb',
    },
]

export const BreadcrumbBox = (props) => {

    useEffect(() => {
        UserService.generateToken();
    })
    const currentLanguageCode = cookies.get('i18next') || 'en'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
    const { t } = useTranslation()

    useEffect(() => {
        document.body.dir = currentLanguage.dir || 'ltr'
        document.title = t('app_title')
    }, [currentLanguage, t])


    const state = {
        backgroundImage: 'breadcrumb-bg.png',
    }


    const imageUrls = (url) => {
        if (url == null) {
            return '';
        } else {
            let imagepath = url.replace(/\\/g, "\\\\");
            return imagepath;
        }
    }


    return (
        <Styles>
            <section className="breadcrumb-area" style={{
                backgroundImage: props.bannerUrl == null
                    ? `url(${process.env.PUBLIC_URL}/assets/images/${state.backgroundImage})`
                    : `url(${imageUrls(props.bannerUrl)})`
            }}>
                <Container>
                    <Row>
                        <Col md="12" className="text-left">
                            <h1 className="breadcrumb-title">{props.title}</h1>
                            {/* <div className="breadcrumb-box">
                                <h2 className="breadcrumb-title">{props.title}</h2>
                                <Breadcrumb>
                                    <Breadcrumb.Item><Link to={process.env.PUBLIC_URL + "/"}>{t('home')}</Link></Breadcrumb.Item>
                                    <Breadcrumb.Item active>{props.title}</Breadcrumb.Item>
                                </Breadcrumb>
                            </div> */}
                        </Col>
                    </Row>
                </Container>
            </section>
        </Styles>
    )

}